import { useState } from 'react';
import { t } from '../lib/i18n.js';

/**
 * A button that asks before it acts (pass 9: Retire had no confirmation). The
 * question appears in place, with the act and a way back; no browser dialog.
 */
export function ConfirmButton({
  label,
  question,
  confirmLabel,
  onConfirm,
  disabled,
  className,
}: {
  label: string;
  question: string;
  confirmLabel: string;
  onConfirm: () => void;
  disabled?: boolean;
  className?: string;
}) {
  const [asking, setAsking] = useState(false);
  if (!asking) {
    return (
      <button type="button" className={className} disabled={disabled} onClick={() => setAsking(true)}>
        {label}
      </button>
    );
  }
  return (
    <span role="group" aria-label={question} className="inline-flex flex-wrap items-center gap-2 text-xs">
      <span>{question}</span>
      <button
        type="button"
        className="rounded border border-tone-critical px-2 py-0.5 text-tone-critical"
        disabled={disabled}
        onClick={() => {
          setAsking(false);
          onConfirm();
        }}
      >
        {confirmLabel}
      </button>
      <button type="button" className="rounded border border-border px-2 py-0.5" onClick={() => setAsking(false)}>
        {t("Keep it")}
      </button>
    </span>
  );
}
